import React, { forwardRef } from 'react';
import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink'; 
import { wrapTrademarkSuperscript } from '../../../utils/cob-utils';
import { IMainNavigationItem } from '../../HeaderComponent/HeaderComponent';

interface RibbonDropdownProps {
    navBarLinks: IMainNavigationItem[];
    isOpen: boolean;
    showSearchInput: boolean;
}

const RibbonDropdown = forwardRef(({ navBarLinks, isOpen, showSearchInput }: RibbonDropdownProps, fwdRef: any) => (
    <div className={`SearchRibbon__dropdown ${isOpen && !showSearchInput ? 'SearchRibbon__dropdown--open' : ''}`}
        style={isOpen ? { maxHeight: fwdRef.current?.clientHeight } : { maxHeight: '0' }}>
        <ul ref={fwdRef}>
            {navBarLinks?.map((link, index) => (
                <li key={index}>
                    <a
                        className='SearchRibbon__stackedLinks'
                        href={link.link + (link.linkParam ?? '')}
                        target={link.linkNewTab ? '_blank' : '_self'}
                        rel='noreferrer'
                    >
                        {transformHTMLParserLinks(wrapTrademarkSuperscript(link.linkTitle))}
                    </a>
                </li>
            ))}
        </ul> 
    </div>
));

export default RibbonDropdown;